import React from 'react';

function EstadisticasFilters({
  filtros,
  onChange,
  onApply,
  onClear,
  onPrint,
  periodoLabel,
  loading,
  printDisabled,
}) {
  const handleSubmit = (event) => {
    event.preventDefault();
    onApply();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="estadisticas-no-print bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-lg p-4 mb-6"
    >
      <div className="flex flex-col xl:flex-row gap-4 xl:items-end xl:justify-between">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="flex flex-col">
            <label className="text-xs text-slate-500 dark:text-slate-400 mb-1">Desde</label>
            <input
              type="date"
              value={filtros.desde}
              onChange={(event) => onChange({ ...filtros, desde: event.target.value })}
              className="bg-slate-50 dark:bg-slate-900/40 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-900 dark:text-slate-100"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-xs text-slate-500 dark:text-slate-400 mb-1">Hasta</label>
            <input
              type="date"
              value={filtros.hasta}
              onChange={(event) => onChange({ ...filtros, hasta: event.target.value })}
              className="bg-slate-50 dark:bg-slate-900/40 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm text-slate-900 dark:text-slate-100"
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center gap-3">
          <div className="rounded-lg bg-slate-50 dark:bg-slate-900/40 border border-slate-100 dark:border-slate-700 px-3 py-2 text-sm text-slate-600 dark:text-slate-300">
            <span className="text-xs uppercase font-semibold text-slate-400 block">Periodo aplicado</span>
            {periodoLabel}
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-sm hover:bg-primary/90 disabled:opacity-60"
            >
              <span className="material-symbols-outlined text-base">
                {loading ? 'progress_activity' : 'filter_alt'}
              </span>
              Aplicar
            </button>
            <button
              type="button"
              onClick={onClear}
              disabled={loading}
              className="inline-flex items-center gap-2 bg-slate-100 dark:bg-slate-900 text-slate-700 dark:text-slate-200 px-4 py-2 rounded-lg text-sm font-semibold border border-slate-200 dark:border-slate-700 disabled:opacity-60"
            >
              <span className="material-symbols-outlined text-base">restart_alt</span>
              Limpiar
            </button>
            <button
              type="button"
              onClick={onPrint}
              disabled={printDisabled}
              className="inline-flex items-center gap-2 bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 px-4 py-2 rounded-lg text-sm font-semibold shadow-sm disabled:opacity-60"
            >
              <span className="material-symbols-outlined text-base">print</span>
              Imprimir reporte
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default EstadisticasFilters;
